import React, { Component } from 'react';

const apiBase = '/v1';

class FolderList extends Component {
  constructor(props) {
    super(props);
    this.state = { openFolders: {} };
  }
  toggleFolder(index) {
    const openFolders = Object.assign({}, this.state.openFolders);
    if (openFolders[index] === true) {
      openFolders[index] = false;
    } else {
      openFolders[index] = true;
    }
    this.setState({ openFolders });
  }
  render() {
    const { toggleFolder } = this;
    const { dirs, files, setActivePath, parentPath, RenderCheckbox, showCheckbox, setActiveFile } = this.props;
    const { openFolders } = this.state;
    return (
      <div>
        <ul className="filelist">
          {dirs.map((v, index) => {
            const isOpen = openFolders[index] === true;
            const handleToggleFolder = () => setActivePath(v.path);
            if (isOpen) {
              return (
                <li key={index}>
                  <input type="checkbox" />
                  <a onClick={handleToggleFolder}>
                    <span className="ti ti-folder" /> {v.name}
                  </a>
                  <FolderList {...v}/>
                </li>
              );
            }
            return (
              <li key={index}>
                {showCheckbox && <RenderCheckbox {...v} />}
                <a onClick={handleToggleFolder}>
                  <span className="ti ti-folder" /> {v.name}
                </a>
              </li>
            );
          })}
          {files.map((v, index) => {
            return (
              <li key={index}>
                {showCheckbox && <RenderCheckbox {...v} />}
                <a
                  onClick={() => setActiveFile(v)}
                  /*target="_blank"
                  href={`${apiBase}/files/${encodeURIComponent(v.getFullName())}`}*/
                >
                  <span className="ti ti-file" /> {v.name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default FolderList;



// WEBPACK FOOTER //
// ./src/components/routes/files/FolderList.js